import React, { lazy,Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch  } from 'react-router-dom'
import { Provider } from 'react-redux';

import App from './app.component';
import Loading from './loading.component';
//import { i } from "shared/services/user.service";
import { PrivateRoute } from "./route/private-router.component";
import { LoginRouter } from "./route/login-router.component";
import { store } from './shared/stores'
import "assets/scss/main.scss";
import { PermissaoRecursos } from 'shared/services/permissao-recursos.service';

const Home = lazy(() => import('./containers/home/index'));
const PrimeiroAcesso = lazy(() => import('./containers/primeiroAcesso'));
const Dashboard = lazy(() => import('./containers/dashboard'));
const Parceiro = lazy(() => import('./containers/parceiros/'));
const Financeiro = lazy(() => import('./containers/financeiro'));
const idExtrato = lazy(() => import('./containers/financeiro/[idExtrato]'));
const Vouchers = lazy(() => import('./containers/vouchers'));
const idVoucher = lazy(() => import('./containers/vouchers/[idVoucher]'));
const idParceiro = lazy(() => import('./containers/parceiros/[idParceiro]'));
const idProduto = lazy(() => import('./containers/parceiros/[idProduto]'));

const permissaoRecurso = PermissaoRecursos

ReactDOM.render(
    <Provider store={store}>
        <Suspense fallback={<Loading />}>
            <BrowserRouter>
                <App>
                    <Switch>
                        <LoginRouter path={"/"} exact={true} component={Home} />
                        <PrivateRoute path={"/primeiro-acesso"} recurso={permissaoRecurso.PAGINA_PRIMEIRO_ACESSO} exact={true} component={PrimeiroAcesso} />
                        <PrivateRoute path={"/dashboard"} exact={true} recurso={permissaoRecurso.PAGINA_DASHBOARD} component={Dashboard} />
                        <PrivateRoute path={"/parceiros"} exact={true} recurso={permissaoRecurso.PAGINA_PARCEIROS} component={Parceiro} />
                        <PrivateRoute path={"/parceiros/:idParceiro"} recurso={permissaoRecurso.PAGINA_PARCEIROS_DETALHAMENTO} exact={true} component={idParceiro} />
                        <PrivateRoute path={"/parceiros/:idParceiro/:idProduto"} recurso={permissaoRecurso.PAGINA_PARCEIROS_DETALHAMENTO_PRODUTO} exact={true} component={idProduto} />
                        <PrivateRoute path={"/vouchers"} exact={true} recurso={permissaoRecurso.PAGINA_VOUCHERS} component={Vouchers} />
                        <PrivateRoute path={"/vouchers/:idVoucher"} recurso={permissaoRecurso.PAGINA_VOUCHERS_DETALHAMENTO} exact={true} component={idVoucher} />
                        <PrivateRoute path={"/extratos"} recurso={permissaoRecurso.PAGINA_FINANCEIRO} exact={true} component={Financeiro} />
                        <PrivateRoute path={"/extratos/:idExtrato"} recurso={permissaoRecurso.PAGINA_FINANCEIRO_DETALHAMENTO} exact={true} component={idExtrato} />
                    </Switch>
                </App>
            </ BrowserRouter>
        </Suspense>
    </Provider>
    , document.getElementById('root')
);
